import { PrimaryButton,TextField,Stack,Text, Label,DefaultEffects,Nav } from '@fluentui/react';
import React,{useState,useEffect } from 'react';

function Stock()
{    
    useEffect(() => {
    document.title = "물타기 계산기";  
    }, []);
    const [state,setState] = useState({
      curAvgPrice:0,
      curCount: 0,
      curTotalPrice: 0,
      addAvgPrice:0,
      addCount: 0,
      addTotalPrice: 0,
      resultAvgPrice:0,
      resultCount: 0,
      resultTotalPrice: 0
    });
   
    function curCalcul(e) {
      const value = parseInt( e.target.value);
      let newState = {...state, [e.target.name]:value};
      newState.curTotalPrice = newState.curCount*newState.curAvgPrice;
      newState.addTotalPrice = newState.addCount*newState.addAvgPrice;
      newState.resultCount = newState.curCount + newState.addCount;
      newState.resultTotalPrice = newState.curTotalPrice+ newState.addTotalPrice;
      newState.resultAvgPrice =  newState.resultTotalPrice  / newState.resultCount ;
      setState(newState);
    }
    return(
 
    <Stack.Item  align='center' tokens={{ }} >
    <Stack tokens={{}}>
      <Text variant="superLarge" block style={{marginBottom:40}}>물타기 계산기</Text>
      <Text variant="large" styles={{}}>
       현재 보유
      </Text>
      <Text variant="small"  style={{color:'gray'}}>
      (현재 보유한 주식의 평균단가, 수량을 입력합니다.)
      </Text>
      <Stack horizontal tokens={{childrenGap: "10" }}  style={{marginTop:10}} wrap >
      <Stack.Item><TextField style={{}} name='curAvgPrice' onChange={function(e){ curCalcul(e); } } placeholder='보유 평단'  suffix="원"/></Stack.Item>
      <Stack.Item><TextField name='curCount' onChange={function(e){ curCalcul(e); } } placeholder='보유 수량' suffix="주" /></Stack.Item>
      <Stack.Item><TextField defaultValue={0} value={`${state.curTotalPrice}`} suffix="원"/></Stack.Item>
      </Stack>
      <Text variant="large" style={{marginTop:10}}>
       추가보유
      </Text>
      <Text variant="small"  style={{color:'gray'}}>
      (추가로 매수할 주식의 평균단가, 수량을 입력합니다.)
      </Text>
      <Stack horizontal tokens={{childrenGap: "10" }}  style={{marginTop:10}}   wrap>
      <Stack.Item>
        <TextField name='addAvgPrice' onChange={function(e){ curCalcul(e); } } placeholder='평단'  suffix="원"/>
        </Stack.Item>
          <Stack.Item>
        <TextField name='addCount' onChange={function(e){ curCalcul(e); } } placeholder='수량' suffix="주" />
        </Stack.Item>
        <Stack.Item>
        <TextField defaultValue={0} value={`${state.addTotalPrice}`} suffix="원"/>
        </Stack.Item>
      </Stack>
      <Text variant="large" style={{marginTop:10}}>
      결과
      </Text>
      <Text variant="small"  style={{color:'gray'}}>
      (물타기 결과 입니다.)
      </Text>
      <Stack horizontal tokens={{childrenGap: "10" }}  style={{marginTop:10}} wrap >
          <Stack.Item>
          <TextField readOnly name='resultAvgPrice' value={`${state.resultAvgPrice}`} placeholder='평단'  suffix="원"/>
          </Stack.Item>
          <Stack.Item>
          <TextField readOnly name='resultCount' value={`${state.resultCount}`} placeholder='수량' suffix="주" />
          </Stack.Item>
          <Stack.Item>
          <TextField readOnly defaultValue={0} value={`${state.resultTotalPrice}`} suffix="원"/>
          </Stack.Item>
      </Stack>
      </Stack>
      </Stack.Item>
    );
}
export default Stock;